import type { RouteRecordRaw } from 'vue-router';

export const documentsRoute: RouteRecordRaw = {
  path: '/documents',
  name: 'Documents',
  component: () => import('./pages/DocumentsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:documents:list'),
  },
};

export const bulkDocumentsRoute: RouteRecordRaw = {
  path: '/documents/bulk',
  name: 'BulkDocuments',
  component: () => import('./pages/BulkDocumentsPage.vue'),
  meta: {
    layout: 'empty',
    authorize: ({ isGranted }) => isGranted('ugi:core:documents:list'),
  },
};

export const documentRoute: RouteRecordRaw = {
  path: '/documents/:id',
  name: 'Document',
  component: () => import('./pages/DocumentPage.vue'),
  meta: {
    layout: 'empty',
    authorize: ({ isGranted }) => isGranted('ugi:core:documents:get'),
  },
};
